import React from 'react';
import FieldForm from '../../FieldForm/FieldForm';
import HtmlRenderer from 'v2/common/HtmlRenderer/HtmlRenderer';
import RichTextEditor from 'v2/form/RichTextEditor/RichTextEditor';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';

const RichTextField = (props: FieldTypeProps) => {
  const { value } = props;

  return (
    <FieldForm
      {...props}
      content={<HtmlRenderer source={String(value)} />}
      renderInput={({ field: { value, onChange } }) => {
        return (
          <RichTextEditor
            value={value}
            onChange={(data) => {
              if (data.length <= 255) {
                onChange(data);
              }
            }}
            autoFocus
          />
        );
      }}
    />
  );
};

export default RichTextField;
